<template>
  <div id="input_password">
    <dd-header
      :isMenuView='false'
    />
    <div class="container">
      <div class="title">
        <h1>初回パスワード設定</h1>
      </div>
      <section id="first_password_input">
        <div class="input_list">
          <ul>
            <li>
              <div>
                <span class="list_key">{{label.password}}</span>
                <span class="important small_text">必須</span>
                <span class="small_p">半角英小文字、数字を含む8字以上20字以下のパスワードを設定してください。</span>
              </div>
              <input type="password" class="list_box" v-model="form.password" placeholder="********" maxlength="20"/>
              <div v-if="errors.password" class="error_text">{{ errors.password }}</div>
            </li>
            <li>
              <div>
                <span class="list_key">{{label.confirmPassword}}</span>
                <span class="important small_text">必須</span>
              </div>
              <input type="password" class="list_box" v-model="form.confirmPassword" placeholder="********" maxlength="20"/>
              <div v-if="errors.confirmPassword" class="error_text">{{ errors.confirmPassword }}</div>
            </li>
          </ul>
        </div>
      </section>
      <span>
        <div v-if="Object.keys(errors).length > 0" class="error_text">入力内容にエラーがあります。項目をご確認の上、もう一度入力してください。</div>
        <div v-else-if="fieldErrorMessages" class="error_text">{{this.fieldErrorMessages}}</div>
      </span>
      <div class="control_btn_area">
        <div class="main_btn sel_sub_btn" @click="confirm()">
          <a>設定</a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import * as Api from '../../utils/Api'
import {DC_URL} from '../../constants/App'
import * as Check from '../../utils/Check'

import Header from '../components/common/DcHeader'
export default {
  name: 'FirstPassword',
  components: {
    'dd-header': Header
  },
  data () {
    return {
      label: {
        password: 'パスワード',
        confirmPassword: '確認用パスワード'
      },
      form: {
        password: '',
        confirmPassword: ''
      },
      errors: {},
      fieldErrorMessages: ''
    }
  },
  methods: {
    confirm: function () {
      // 入力チェック
      this.errors = {}

      this.validateRequire()
      if (Object.keys(this.errors).length !== 0) {
        return
      }
      this.validateFormat()
      if (Object.keys(this.errors).length !== 0) {
        return
      }
      let payload = {
        password: this.form.password,
        confirmPassword: this.form.confirmPassword
      }
      axios.post(DC_URL.PASSWORD + '/update', payload)
        .then(response => {
          if (response.data.errorMessage) {
            this.fieldErrorMessages = response.data.errorMessage
          } else {
            alert('パスワード変更設定しました')
            this.$router.push('/mmstyle/top')
          }
        }).catch(error => {
          Api.handleError(error, this.errorMessage, this.fieldErrorMessages)
        })
    },
    validateRequire: function () {
      if (!this.form.password) {
        // this.errors['password'] = this.label.password + 'は必須項目です。'
        this.$set(this.errors, ['password'], this.label.password + 'は必須項目です。')
      }
      if (!this.form.confirmPassword) {
        // this.errors['confirmPassword'] = this.label.confirmPassword + 'は必須項目です。'
        this.$set(this.errors, ['confirmPassword'], this.label.confirmPassword + 'は必須項目です。')
      }
    },
    validateFormat: function () {
      if (!Check.isPassword(this.form.password)) {
        this.$set(this.errors, ['password'], this.label.password + 'は半角英小文字、数字を含む8字以上20字以下のパスワードを設定してください。')
      }
      if (!Check.isPassword(this.form.confirmPassword)) {
        this.$set(this.errors, ['confirmPassword'], this.label.confirmPassword + 'は半角英小文字、数字を含む8字以上20字以下のパスワードを設定してください。')
      }
    }
  }
}
</script>
<style src="../css/dc-order.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/main/js/payment/pages/DcFirstPassword.vue